import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './language/en';
import { ua } from './language/ua';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ua: { translation: ua },
    },
    lng: localStorage.getItem('pv-lang') || 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
